import { Caption, useStyles } from '@archipro-design/aria';
import * as S from './SearchResultCarousels.style';
import { Link, useLocation } from '@remix-run/react';

interface SearchResultCarouselsProps {
    productTiles: JSX.Element[];
    productCount: number;
    professionalTiles: JSX.Element[];
    professionalCount: number;
    projectTiles: JSX.Element[];
    projectCount: number;
    articleTiles: JSX.Element[];
    articleCount: number;
}

export const SearchResultCarousels = ({
    productTiles,
    productCount,
    professionalTiles,
    professionalCount,
    projectTiles,
    projectCount,
    articleTiles,
    articleCount,
}: SearchResultCarouselsProps) => {
    const { css } = useStyles();

    return (
        <div className={css(S.Wrapper)}>
            {productTiles && (
                <SearchResultCarousel
                    tiles={productTiles}
                    itemType="Products"
                    itemCount={productCount}
                />
            )}
            {projectTiles && (
                <SearchResultCarousel
                    tiles={projectTiles}
                    itemType="Projects"
                    itemCount={projectCount}
                />
            )}
            {professionalTiles && (
                <SearchResultCarousel
                    tiles={professionalTiles}
                    itemType="Professionals"
                    itemCount={professionalCount}
                />
            )}
            {articleTiles && (
                <SearchResultCarousel
                    tiles={articleTiles}
                    itemType="Articles"
                    itemCount={articleCount}
                />
            )}
        </div>
    );
};

const SearchResultCarousel = ({
    tiles,
    itemType,
    itemCount = 0,
}: {
    tiles: JSX.Element[];
    itemType: string;
    itemCount?: number;
}) => {
    const { css } = useStyles({ itemType });
    const location = useLocation();

    if (tiles.length === 0) return null;

    const targetCategory = '/category_' + itemType.toLowerCase();
    const newUrl = location.pathname + targetCategory + location.search;

    return (
        <div className={css(S.CarouselsRow)}>
            <Caption
                className={css(S.CarouselsRowHeader)}
                variant="04"
            >{`${itemType} (${itemCount})`}</Caption>
            <div className={css(S.CarouselContainer)}>
                {tiles.map((tile, index) => (
                    <div key={index} className={css(S.ItemContainer)}>
                        {tile}
                    </div>
                ))}
                <Link to={newUrl} className={css(S.ViewMore)}>
                    View all
                </Link>
            </div>
        </div>
    );
};
